import { StudentRepository } from '@/repository/StudentRepository'
import { ParentRepository } from '@/repository/ParentRepository'
import { TeacherRepository } from '@/repository/TeacherRepository'
import { Parent } from '@/models/Parent'
import { Teacher } from '@/models/Teacher'
import { Student } from '@/models/Student'

import { HasLessonsError } from './errors'

class RelationsBreaker {

  constructor(client, user, opt_student=null) {
    if (!(client)) {
      throw new TypeError(`'client' is required`)
    }
    this.breaker = RelationsBreakerFactory.create(client, user, opt_student)
  }

  async execute(id) {
    return await this.breaker.execute(id)
  }
}

class RelationsBreakerFactory {

  static create(client, user, opt_student) {
    if (user instanceof Teacher) {
      return new TeacherRelationsBreaker(client, user)
    } else if (user instanceof Parent) {
      return new StudentRelationsBreaker(client, user, opt_student)
    } else {
      throw new TypeError(`'user' must be an instance of either [object Parent] or [object Teacher]. Actual: ${typeof user}`)
    }
  }
}

class StudentRelationsBreaker {
  constructor(client, parent, student) {
    if (!(student instanceof Student)) {
      throw new TypeError(`'student' must be an instance of [object Student]. Actual: ${typeof student}`)
    }
    this.studentRepo = new StudentRepository(client)
    this.parentRepo = new ParentRepository(client)
    this.teacherRepo = new TeacherRepository(client)
    this.parent = parent
    this.student = student
  }

  async execute(teacherId) {
    if(!(typeof teacherId === 'string')) {
      throw new TypeError(`The type of 'teacherId' must be String. Actual: ${typeof teacherId}`)
    }
    this._canDelete(teacherId)
    let teacher = await this.teacherRepo.find(teacherId)
    await this.teacherRepo.update(teacher.removeStudentId(this.student.getId()))
    this.student = await this.studentRepo.update(this.student.removeTeacherId(teacherId))
    return await this.parentRepo.update(this.parent.updateStudent(this.student).removeTeacherId(teacherId))
  }

  _canDelete(teacherId) {
    if (this.student.getLessons().filterByTeacherId(teacherId).hasLessons()) {
      throw new HasLessonsError(`授業予定を削除してください`)
    }
  }
}

class TeacherRelationsBreaker {
  constructor(client, teacher) {
    this.studentRepo = new StudentRepository(client)
    this.parentRepo = new ParentRepository(client)
    this.teacherRepo = new TeacherRepository(client)
    this.teacher = teacher
  }

  async execute(studentId) {
    if(!(typeof studentId === 'string')) {
      throw new TypeError(`The type of 'studentId' must be String. Actual: ${typeof studentId}`)
    }
    this._canDelete(studentId)
    let student = await this.studentRepo.find(studentId)
    let parent = await this.parentRepo.find(student.parentId)
    student.teacherIds.splice(student.teacherIds.findIndex(id => id === this.teacher.getId()), 1)
    parent.teacherIds.splice(parent.teacherIds.findIndex(id => id === this.teacher.getId()), 1)
    await this.parentRepo.update(parent.updateStudent(await this.studentRepo.update(student)))
    this.teacher.studentIds.splice(this.teacher.studentIds.findIndex(id => id === studentId), 1)
    return await this.teacherRepo.update(this.teacher)
  }

  _canDelete(studentId) {
    if (this.teacher.getLessons().filterByStudentId(studentId).hasLessons()) {
      throw new HasLessonsError(``)
    }
  }
}

export { RelationsBreaker }